import AuthService from '../../AuthService';
const userRole = {
  getUserRole(page,search,sort_date){
    return AuthService.get(`user_role?page=${page}&search=${search}&sort_date=${sort_date}`);
  },
  showUserRole(id){
    return AuthService.get(`user_role/${id}`);
  },
  createUserRole(data){
    return AuthService.post(`user_role`,data);
  },
  updateUserRole(id,data){
    return AuthService.put(`user_role/${id}`,data);
  },
  deleteUserRole(id){
    return AuthService.delete(`user_role/${id}`);
  },
  getAllUserRole(){
    return AuthService.get(`user_role_all`);
  },
  getAllFeature(){
    return AuthService.get(`feature`);
  },
}
export default userRole
